import iosBridge from '../store/ios_bridge'
import logout from './logout';
import moment from 'moment';
import md5 from 'md5';
const { v4: uuidv4 } = require('uuid');
import aes256 from "aes256";

/* Register open link function globally in our project pass url and redirect detected browser
*  this function is helpfull if you make hard html from any function and component rether then vue
*  currently is call in utility.replaceUrlIntoLink
*/
window.open_link = function(url){
  utility.open_link(url);
}

var utility = {
  /**
   * get_message_datetime
   * Get the latest message date time. If date is today then show time else date
   */
  get_message_datetime(message_time, format = "DD/MM/YYYY", timestamp = true, same_date_filter = true) {
    var msg_date = "";
    var date_time = '';
    if(timestamp){
      date_time = parseInt(message_time);
    }
    else{
      date_time = String(message_time);
    }

    //check date is same as current date
    var is_same_date = this.moment(date_time).isSame(this.moment(), 'day');
    if (is_same_date && same_date_filter) {
      msg_date = this.moment(date_time).format('HH:mm');
    }
    else{
     msg_date = this.moment(date_time).format(format);
    }
    return msg_date;
  },
  /*
   * preview_img
   * */
  preview_img(context) {
    let preview = context.$refs.image;
    let file = context.$refs.inputUpload.files[0];
    if(file){
      let reader  = new FileReader();
      reader.onloadend = function () {
        preview.src = reader.result;
      };
      if (file) {
        reader.readAsDataURL(file);
      } else {
        preview.src = "";
      }
    }
  },
  /*
   * isValidUrl
   * */
  isValidUrl(url) {
    try {
      new URL(url);
      return true;
    } 
    catch (_) {
      return false;
    }
  },
  /*
   * detectUrlFromText
   * */  
  detectUrlFromText(text){
    var matches = text.match(/\bhttps?:\/\/\S+/gi);
    return matches;

  },
  /*
   * htmlEncode
   * 
   * */  
  htmlEncode(string) { 
    var i = string.length, 
        a = []; 

    while (i--) { 
        var iC = string[i].charCodeAt(); 
        if (iC < 65 || iC > 127 || (iC > 90 && iC < 97)) { 
            a[i] = '&#' + iC + ';'; 
        } else { 
            a[i] = string[i]; 
        } 
    } 
    return a.join(''); 
  },
  /*
   * replaceUrlIntoLink
   * */  
  replaceUrlIntoLink(text){
    const URLMatcher = /(?:(?:https?|ftp|file):\/\/|www.|ftp.)(?:([-A-Z0-9+&@#/%=~_|$?!:,.]*)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:([-A-Z0-9+&@#/%=~_|$?!:,.]*)|[A-Z0-9+&@#/%=~_|$])/igm
    const withLinks = text.toString().replace(URLMatcher, match => `<a class="chat_box_rich_message_link"  onclick="open_link('${match}')" href="javascript:void(0);"><span class="userSelectionPointerAllow">${match}<span></a>`);
    return withLinks;
  },
  /*
   * moment
   * Its used for full functionality of momentjs not need to import again and used
   * like utility.moment
  * */ 
  moment: moment,
  /**
   * copy_text
   */
  copy_text: function (context, item) {
    var dummy = document.createElement("textarea");

    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = item;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);

    context.snackbar = true;
    context.err_msg = 'Copied';
  },
  /**
  * update_current_url - Update the Visible URL on Browser
  *
  */
  update_current_url(url_key, url_val=null, remove_query_string=true){
    //Update the Visible URL on Browser
    var curr_url = new URL(location.href);

    if(remove_query_string){
      //Remove the entire query string
      curr_url =  window.location.href.split("?")[0];
    }
    else{
      //Remove the selected value from query string
      var params = new URLSearchParams(curr_url.searchParams.toString());
      params = params.toString();
  
      if(params.indexOf(url_key) != -1){
        //Found the Param. Now Remove it    
        curr_url.searchParams.delete(url_key);    
      }
      
      if(url_val != null){
        if(curr_url.toString().indexOf("?") != -1){
          //If Found
          curr_url = curr_url + "&" + url_key + "=" + url_val;  
        }
        else{
          curr_url = curr_url + "?" + url_key + "=" + url_val;   
        }
      } 
    }
    
    if (history.pushState) {
      window.history.pushState({path:curr_url},'',curr_url);
    }
  },
  /**
   * getUniqueId - While creating a Group, New Message or One-to-One Group
   */
  getUniqueId(user_id, some_id_or_data){
    let time = new Date().getTime();
    return md5(user_id+some_id_or_data+uuidv4()+time);
  },
  /**
   * displaySnackBar
   */
  displaySnackBar(context, source, msg){
    context.snackbar = true;
    context.err_msg = msg;

    setTimeout(() => {
      logout.logout(source+":"+msg);
    }, 3000);
  },
  /*
  * aes_encrypt
  * */
  aes_encrypt(key, data) {
    key = key+process.env.VUE_APP_AES_SALT;
    let cipher = aes256.createCipher(key);
    return cipher.encrypt(data);
  },
  /*
  * aes_decrypt
  * */
  aes_decrypt(key, data) {
    key = key+process.env.VUE_APP_AES_SALT;
    let cipher = aes256.createCipher(key);
    return cipher.decrypt(data);
  },
  /*
  * gide_aes_encrypt
  * */
  gide_aes_encrypt(key, data) {
    key = key+process.env.VUE_APP_GIDE_AES_SALT;
    let cipher = aes256.createCipher(key);
    return cipher.encrypt(data);
  },
  /*
  * gide_aes_decrypt
  * This method is used to decrypt the user's data sent from the parent app when mesh is used on such apps as iframe
  */
  gide_aes_decrypt(key, data) {
    key = key+process.env.VUE_APP_GIDE_AES_SALT;
    let cipher = aes256.createCipher(key);
    return cipher.decrypt(data);
  },
  /*
  * open_link
  * */
  open_link(url){
    if(window.webkit){
      iosBridge.sendMessage({"module":"launchInBrowser", "data":{"url":url}});          
    }
    else{
      window.open(url, '_blank');
    }
  },
  /**
    * getUserTags for mention user
    */
   getUserTags(message){
    var regex = new RegExp('{@userid_'+'(.*?)'+'}', 'gm');
    var tagStrArr = message.match(regex);
    return tagStrArr;
  },
  /**
   * openFileBrowser
   */
  openFileBrowser(self, allowedMimeType=null) {
    self.mention_users_for_attachment = self.users;
    self.allowedMimeType = process.env.VUE_APP_ALLOWED_MIME_TYPES+","+allowedMimeType;
    self.$nextTick(() => {
      self.$refs.attachmentFileUpload.click();
    });
  },
  /**
  * replaceUserIdMicro 
  * User tag with user name by user id for mention user
  */
  replaceUserIdMicro(message, tagStrArr, user_contact_list, link = false, board_view = false){
    if(user_contact_list){
      if(tagStrArr){
        tagStrArr.forEach((tag) => {
          if(tag){
            var userTag = tag.replace('{', '').replace('}','').split('_');
            var user_id = userTag[1].trim();
            var user_name = "";
            if(userTag[2]){
              user_name = userTag[2].trim();
            }
          
            //If the method is called from board view than the html is not needed.
            if(board_view) {
              if (user_contact_list[user_id]) {
                user_name ='@'+user_contact_list[user_id]["user_name"];
                message = message.replace(tag, user_name);
              }
              else {
                user_name ='@'+user_name;
                message = message.replace(tag, user_name);
              }
            }
            else {
              if(user_contact_list[user_id]){
                let user_name_link =  `<a`;
                if(link){
                  //go_to_participant_profile is define in app.vue for globally function
                  user_name_link += ` onclick="go_to_participant_profile('`+user_id.trim()+`')"`;
                }
                user_name_link += ` href="javascript:void(0)" class="user_tag_link"><span class="at_symbol">@</span>`;
                user_name_link += user_contact_list[user_id]['user_name'] + `</a>`;
                message = message.replace(tag, user_name_link);
              }
              else{
                //If User Not Found then dont show any formatting
                user_name = `<span class="at_symbol">@</span>` + user_name;
                message = message.replace(tag, user_name);
              }
            }
          }
        });
      }
    }
    else{
      /* Its only on for chatgroup list becouse there are getting contact list api call 
       * that is async sometime it fetch details first and some time last it is last then get user name from tags
      */
       if(tagStrArr){
        tagStrArr.forEach((tag) => {
          if(tag){
            var userTag = tag.replace('{', '').replace('}','').split('_');
            var user_id = userTag[1].trim();
            var user_name = "";
            if(userTag[2]){
              user_name = userTag[2].trim();
            }
           
            let user_name_link =  `<a`;
            if(link){
              //go_to_participant_profile is define in app.vue for globally function
              user_name_link += `onclick="go_to_participant_profile('`+user_id.trim()+`')"`;
            }
            user_name_link += `href="javascript:void(0)" class="user_tag_link"><span class="at_symbol">@</span>`;
            user_name_link += user_name + `</a>`;
            message = message.replace(tag, user_name_link);
          }
        });
      }
    }
    
    return message;
  }
};

export default utility;
